import { useState } from 'react';
import styles from './style.module.css';
import { ApiResponse, KurultaiResponse, RegionData, CategoryData } from '../api/types';

interface LeftTableProps {
    data?: ApiResponse<KurultaiResponse>;
    isLoading?: boolean;
}

export const LeftTable: React.FC<LeftTableProps> = ({ data, isLoading }) => {
    const [expandedAreas, setExpandedAreas] = useState<{[key: string]: boolean}>({});

    const toggleArea = (areaName: string) => {
        setExpandedAreas(prev => ({
            ...prev,
            [areaName]: !prev[areaName]
        }));
    };

    if (isLoading) {
        return (
            <div className={styles.container}>
                <div className={styles.title}>Общие данные</div>
                <div className={styles.totalCount}>Загрузка данных...</div>
                <div className={styles.header}>
                    <span>Области</span>
                    <span>Кол-во вопросов</span>
                </div>
                <div className={styles.noData}>Загрузка...</div>
            </div>
        );
    }

    if (!data?.res?.data?.length) {
        return (
            <div className={styles.container}>
                <div className={styles.title}>Общие данные</div>
                <div className={styles.totalCount}>Всего задач: 0</div>
                <div className={styles.header}>
                    <span>Области</span>
                    <span>Кол-во вопросов</span>
                </div>
                <div className={styles.noData}>Нет данных</div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.title}>Общие данные</div>
            <div className={styles.totalCount}>Всего задач: {data.res.totalTasks}</div>
            
            <div className={styles.header}>
                <span>Области</span>
                <span>Кол-во вопросов</span>
            </div>
            
            <ul className={styles.districtList}>
                {data.res.data.map((area: RegionData) => (
                    <li key={area.nameRu} className={styles.districtItem}>
                        <div className={styles.districtHeader}>
                            <button 
                                className={styles.expandButton}
                                onClick={() => toggleArea(area.nameRu)}
                            >
                                {expandedAreas[area.nameRu] ? '−' : '+'}
                            </button>
                            <span className={styles.districtName}>{area.nameRu}</span>
                            <span className={styles.questionCount}>
                                {area.amount} ({area.percentageOfExecuted}% вып.поруч.)
                            </span>
                        </div>
                        {expandedAreas[area.nameRu] && (
                            <ul className={styles.categoryList}>
                                {area.categoriesData.map((category: CategoryData) => (
                                    <li key={category.nameRu} className={styles.categoryItem}>
                                        <span>{category.nameRu}</span>
                                        <span>{category.amount} ({category.percentageOfExecuted}% вып.поруч.)</span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};